export default __webpack_public_path__ + "static/media/dark-file.914b324e.svg";